import { Injectable } from '@angular/core';

import { ClientConfigProductName, ContentService } from '@frontend/vanilla/core';
import { Subject } from 'rxjs';

import { DashboardContent, RewardsHubSegments, RewardsHubSegmentsContentPath } from './model';

@Injectable({
    providedIn: 'root',
})
export class ToggleNavigationService {
    isPromoActive: boolean = true;
    promoOffersRoute: string = '';
    rewardsHubRoute: string = '';
    rewardsHubSegments: RewardsHubSegments;
    isContentLoaded: Subject<boolean> = new Subject<boolean>();

    constructor(private contentService: ContentService) {
        this.loadDashboardContent();
    }

    private loadDashboardContent(): void {
        this.contentService
            .getJsonFiltered<DashboardContent>(RewardsHubSegmentsContentPath, ClientConfigProductName.PROMO)
            .subscribe((dashboardContent: DashboardContent) => {
                this.rewardsHubSegments = dashboardContent.messages;
                this.isContentLoaded.next(true);
            });
    }
}
